import React from 'react';
import { useMenuBuilder } from '../../context/MenuBuilderContext';
import { cn } from '../../lib/utils';

export const MenuPreview = ({ className }) => {
  const { menuData } = useMenuBuilder();
  
  const isCompact = menuData.size.height === 843;

  return (
    <div 
      className={cn("glass-panel rounded-lg p-4", className)}
      data-testid="menu-preview"
    >
      <p className="label-text mb-3">Preview</p>
      
      {/* Phone mockup */}
      <div className="bg-[#18181B] rounded-2xl p-2 max-w-[200px] mx-auto">
        {/* Status bar */}
        <div className="h-6 flex items-center justify-between px-3">
          <span className="text-[10px] text-[#52525B]">9:41</span>
          <div className="flex gap-1">
            <div className="w-3 h-3 rounded-full bg-[#27272A]" />
            <div className="w-3 h-3 rounded-full bg-[#27272A]" />
          </div>
        </div>
        
        {/* Chat area */}
        <div className="bg-[#09090B] rounded-lg h-32 mb-2 p-2">
          <div className="flex items-start gap-2">
            <div className="w-6 h-6 rounded-full bg-[#06C755]" />
            <div className="bg-[#27272A] rounded-lg px-3 py-2 max-w-[80%]">
              <p className="text-[10px] text-[#A1A1AA]">Welcome!</p>
            </div>
          </div>
        </div>

        {/* Rich menu */}
        <div 
          className="relative bg-[#27272A] rounded-lg overflow-hidden"
          style={{ aspectRatio: isCompact ? '2500/843' : '2500/1686' }}
        >
          {menuData.imageUrl ? (
            <img
              src={menuData.imageUrl}
              alt="Menu"
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-[8px] text-[#52525B]">Rich Menu</span>
            </div>
          )}
          
          {/* Area overlays */}
          {menuData.areas.map((area, index) => {
            const scaleX = 100 / menuData.size.width;
            const scaleY = 100 / menuData.size.height;
            
            return (
              <div
                key={index}
                className="absolute border border-white/20"
                style={{
                  left: `${area.bounds.x * scaleX}%`,
                  top: `${area.bounds.y * scaleY}%`,
                  width: `${area.bounds.width * scaleX}%`,
                  height: `${area.bounds.height * scaleY}%`
                }}
              />
            );
          })}
        </div>

        {/* Chat bar */}
        <div className="mt-2 bg-[#27272A] rounded-lg px-3 py-2 flex items-center justify-between">
          <span className="text-[10px] text-[#A1A1AA] truncate flex-1">
            {menuData.chatBarText || 'Menu'}
          </span>
          <svg className="w-3 h-3 text-[#52525B]" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>

      {/* Stats */}
      <div className="mt-4 pt-4 border-t border-[#27272A] space-y-2">
        <div className="flex justify-between text-xs">
          <span className="text-[#52525B]">Areas</span>
          <span className="font-mono text-[#A1A1AA]">{menuData.areas.length}/20</span>
        </div>
        <div className="flex justify-between text-xs">
          <span className="text-[#52525B]">Type</span>
          <span className="text-[#A1A1AA]">{isCompact ? 'Compact' : 'Full'}</span>
        </div>
      </div>
    </div>
  );
};

export default MenuPreview;
